import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollManager = () => {
    const location = useLocation();

    useLayoutEffect(() => {
        // Disable browser automatic scroll restoration
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }

        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [location.pathname, location.search, location.hash]);

    return null;
};

export default ScrollManager;
